import { SacTransportComponent } from './component/transports/sac-transports.component';
import { SacStationsComponent } from './component/stations/sac-stations.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SacClientContainerComponent } from './component/sac-client-container/sac-client-container.component';
import { GroupedListTitleComponent } from './component/grouped-list-title/grouped-list-title.component';
import { TransportListEntryComponent } from './component/transport-list-entry/transport-list-entry.component';
import { TransportDetailsListEntryComponent } from './component/transport-details-list-entry/transport-details-list-entry.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { SacStationItemComponent } from './component/stations/sac-station-item/sac-station-item.component';
import { SacStationDetailsComponent } from './component/stations/sac-station-details/sac-station-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DictionaryModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SacBeginUmbrueckungDialogComponent } from './component/umbrueckung/sac-begin-umbrueckung-dialog.component';
import { SacCompleteUmbrueckungDialogComponent } from './component/umbrueckung/sac-complete-umbrueckung-dialog.component';
import { CancelTransportDialogComponent } from './component/cancel-transport-dialog/cancel-transport-dialog.component';
import { StationSelectionModule } from 'src/tmc-yard/components/station-selection/station-selection.module';
import { StationTransortActionBarComponent } from './component/stations/sac-station-details/station-transport-action-bar/station-transport-action-bar.component';
import { TMCTableModule } from '@sdbn/appclient';
import { WaitingAreaDetailsComponent } from './component/stations/sac-station-details/waiting-area-details/waiting-area-details.component';
import { StationTransportDetailsComponent } from './component/stations/sac-station-details/station-transport-details/station-transport-details.component';
import { SacWorkingAreaComponent } from './component/stations/sac-working-area/sac-working-area.component';
import { SuspendStationDialogComponent } from './component/stations/sac-working-area/suspend-station-dialog/suspend-station-dialog.component';
import { SacHeaderContainerComponent } from './component/sac-header-container/sac-header-container.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { SacHeaderTabComponent } from './component/header-tab/header-tab.component';
import { EmptyWorkingAreaItemComponent } from './component/stations/empty-workingarea-item/empty-workingarea-item.component';
import { UsedWorkingareaItemComponent } from './component/stations/used-workingarea-item/used-workingarea-item.component';
import { WaitingAreaItemComponent } from './component/stations/waiting-area/waiting-area-item.component';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { TransportOptionSelectionComponent } from './component/transport-option-selection/transport-option-selection.component';
import { TransportOptionGcConnectionDialogComponent } from './component/transport-option-gc-connection-dialog/transport-option-gc-connection-dialog.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ForwardToStationModule } from '../forward-to-station/forward-to-station.module';
import { CommonFormattingModule, CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { CreateMovingOrderComponent } from './component/create-moving-order/create-moving-order.component';
import { MovingOrderTransportSelectionComponent } from './component/planned-transport-selection/planned-transport-selection.component';
import { MovingOrderVehicleSelectionComponent } from './component/moving-order-vehicle-selection/moving-order-vehicle-selection.component';
import { LoadingZoneSelectionComponent } from './component/loading-zone-selection/loading-zone-selection.component';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { TransportOptionsEditorModule } from 'src/tmc-yard/components/transport-options-editor/transport-options-editor.module';
import { TransportOptionsPanelModule } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.module';
import { MobileSacStationTitleComponent } from './component/mobile/station-tile/station-title.component';
import { MobileStationDetailsComponent } from './component/mobile/station-details/station-details.component';
import { MobileStationSelectionMenuComponent } from './component/mobile/mobile-station-selection-menu/station-selection-menu.component';
import { MobileSacTransportDetailsComponent } from './component/mobile/transport-details/transport-details.component';
import { MobileSacTransportActionsComponent } from './component/mobile/transport-actions/transport-actions.component';
import { MobileSacTransportDocumentsComponent } from './component/mobile/transport-documents/transport-documents.component';
import { TransportDocumentsModule } from '../transport-documents/transport-documents.module';
import { MobileSACComponent } from './component/mobile/mobile-sac/mobile-sac.component';
import { TaskAssignmentModule } from 'src/tmc-yard/components/task-assignment/task-assignment.module';
import { ActionsModule } from '../../../control/actions/actions.module';
import { ManagePlannedAssignmentsComponent } from './component/manage-planned-assignments/manage-planned-assignments.component';
import { PlannedAssignmentListEntryComponent } from './component/manage-planned-assignments/planned-assignment-list-entry/planned-assignment-list-entry.component';
import { PlannedAssignmentDetailsListEntryComponent } from './component/manage-planned-assignments/planned-assignment-details-list-entry/planned-assignment-details-list-entry.component';
import { SelectRoutingPositionComponent } from './component/manage-planned-assignments/select-routing-position/select-routing-position.component';
import { SACStationTabletComponent } from './component/station-tablet/sac-station-tablet/sac-station-tablet.component';
import { SACStationTabletPlannedAssignmentsComponent } from './component/station-tablet/planned-station-assignments/sac-station-tablet-planned-assignments.component';
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';
import { AppClientUIModule } from '@sdbn/appclient';

@NgModule({
  declarations: [
    SacClientContainerComponent,
    SacStationsComponent,
    SacTransportComponent,
    GroupedListTitleComponent,
    TransportListEntryComponent,
    TransportDetailsListEntryComponent,
    SacStationItemComponent,
    SacStationDetailsComponent,
    SacBeginUmbrueckungDialogComponent,
    SacCompleteUmbrueckungDialogComponent,
    CancelTransportDialogComponent,
    StationTransortActionBarComponent,
    WaitingAreaDetailsComponent,
    StationTransportDetailsComponent,
    SacWorkingAreaComponent,
    SuspendStationDialogComponent,
    SacHeaderContainerComponent,
    SacHeaderTabComponent,
    EmptyWorkingAreaItemComponent,
    UsedWorkingareaItemComponent,
    WaitingAreaItemComponent,
    TransportOptionSelectionComponent,
    TransportOptionGcConnectionDialogComponent,
    CreateMovingOrderComponent,
    MovingOrderTransportSelectionComponent,
    MovingOrderVehicleSelectionComponent,
    LoadingZoneSelectionComponent,
    MobileSACComponent,
    MobileSacStationTitleComponent,
    MobileStationDetailsComponent,
    MobileStationSelectionMenuComponent,
    MobileSacTransportDetailsComponent,
    MobileSacTransportActionsComponent,
    MobileSacTransportDocumentsComponent,
    ManagePlannedAssignmentsComponent,
    PlannedAssignmentListEntryComponent,
    PlannedAssignmentDetailsListEntryComponent,
    SelectRoutingPositionComponent,
    SACStationTabletComponent,
    SACStationTabletPlannedAssignmentsComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonFormattingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TransportDetailsModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    TransportInfoPanelModule,
    StationSelectionModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    TmcYardCommonModule,
    TransportOptionsEditorModule,
    QRCodeModule,
    ForwardToStationModule,
    DictionaryModule,
    TmcYardCommonModule,
    ServiceResponseModule,
    TransportOptionsPanelModule,
    TransportDocumentsModule,
    TaskAssignmentModule,
    ActionsModule,
    AppClientUIModule
  ],
  exports: [

  ]
})
export class SacClientModule { }
